export default __webpack_public_path__ + "/dist/images/network_active.44bf54471815994e41bd7d0fcaf12c5a.svg";